import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const ApteneoRozliczeniaPage = lazy(() =>
	import("@/features/apteneo/rozliczenia-page").then((m) => ({
		default: m.ApteneoRozliczeniaPage,
	})),
);

// Okres, zakres, udzial GAP i filtry deep-linkowalne — link „Q2 2026, GAP 55%"
// ma otworzyc ten sam widok. `.catch()` na kazdym polu: zly param ze starej
// zakladki nie moze wywalic trasy ZodErrorem (FARMASTER-FRONTEND-31/33/34).
const searchSchema = z.object({
	rok: z.number().int().min(2000).max(2100).optional().catch(undefined),
	kwartal: z.number().int().min(1).max(4).optional().catch(undefined),
	scope: z.string().optional().catch(undefined),
	udzialGap: z.number().min(0).max(100).optional().catch(undefined),
	tylkoKontrakt: z.boolean().optional().catch(undefined),
	ukryjNieporownywalne: z.boolean().optional().catch(undefined),
	zakladka: z.enum(["pozycje", "kontrakty", "kwartaly"]).optional().catch(undefined),
});

export type ApteneoRozliczeniaSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/apteneo/rozliczenia")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.apteneo.rozliczenia",
			location.pathname,
		);
	},
	component: ApteneoRozliczeniaPage,
	validateSearch: (search: Record<string, unknown>): ApteneoRozliczeniaSearch =>
		searchSchema.parse(search),
});
